import React from 'react';
import { useTheme } from '../context/ThemeContext';

const MaintenanceModal = () => {
  // Tenta obter o logo do tema, com fallback seguro
  const { logoUrl } = useTheme() || {};
  const finalLogoUrl = logoUrl || 'https://i.ibb.co/60m6XbM/LOGO-KATEDRAL-WEB.png';

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#0a0a0a] text-white p-6 overflow-hidden">

      {/* Background Effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Top Glow */}
        <div className="absolute top-[-10%] left-1/2 transform -translate-x-1/2 w-[120%] h-[50%] bg-gradient-to-b from-brand-orange-primary/20 to-transparent blur-[120px] opacity-60"></div>

        {/* Bottom Glow */}
        <div className="absolute bottom-[-10%] left-1/2 transform -translate-x-1/2 w-[100%] h-[40%] bg-brand-orange-accent/10 blur-[100px]"></div>

        {/* Grid Pattern */}
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay"></div>
      </div>

      <div className="relative z-10 w-full max-w-lg flex flex-col items-center text-center space-y-12 animate-in fade-in zoom-in duration-700">



        {/* Content Section */}
        <div className="space-y-6 max-w-md mx-auto">
          <div className="space-y-2">
            <h2 className="text-sm font-bold tracking-[0.2em] text-brand-orange-primary uppercase opacity-90">
              Comunicado Oficial
            </h2>
            <h1 className="text-4xl md:text-5xl font-black tracking-tight text-white leading-tight">
              Pausa para <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-orange-primary via-orange-400 to-brand-orange-accent">
                Reinvenção
              </span>
            </h1>
          </div>

          <p className="text-gray-400 text-lg font-medium leading-relaxed">
            Estamos preparando uma nova experiência para você.
            O Katedral que você conhece vai ficar ainda melhor.
          </p>

          <div className="h-px w-24 bg-gradient-to-r from-transparent via-gray-700 to-transparent mx-auto pt-4"></div>
        </div>

        {/* CTA Section */}
        <div className="w-full space-y-4">
          <a
            href="https://chat.whatsapp.com/BvvtMJ4R6FR7mP36yvTB2d"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative w-full flex items-center justify-center gap-4 bg-[#25D366] hover:bg-[#1faa53] text-white font-bold py-4 px-8 rounded-2xl transition-all duration-300 shadow-[0_0_20px_rgba(37,211,102,0.3)] hover:shadow-[0_0_30px_rgba(37,211,102,0.5)] transform hover:-translate-y-1 overflow-hidden"
          >
            <svg className="w-7 h-7 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
            </svg>
            <span className="text-lg tracking-wide">Entrar na Comunidade VIP</span>

            {/* Shine Effect */}
            <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-20 group-hover:animate-shine" />
          </a>

          <p className="text-gray-500 text-xs font-medium uppercase tracking-widest">
            Saiba das novidades em primeira mão
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="absolute bottom-6 text-gray-700 text-xs font-medium tracking-wide">
        &copy; {new Date().getFullYear()} Grupo Stage
      </div>
    </div>
  );
};

export default MaintenanceModal;
